// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"LeaderboardsSection_noScrolling__k4rSc","container":"LeaderboardsSection_container__H8HbF","statsContainer":"LeaderboardsSection_statsContainer__wADZT"};